import type { FaireProductEntity } from "../../entity_types/product";

export const p_2wrsmrvsmb: FaireProductEntity = {
  token: "p_2wrsmrvsmb",
  type: "product",
  name: "Rose-Infused Body Care Set",
  brandToken: "b_hcbhgx8v9w",
  brandName: "123 Farm",
  imageUrl:
    "https://cdn.faire.com/fastly/745da4eae1098564844d0ebe20db7787057610e54bfefdb43013561af96464df.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f14971856da61bc13140c6e85653878cfcd84cd3b4869b353da7f61fcbb0be24.jpeg",
  ],
  priceDollars: 14,
  description:
    "Treat someone special (or yourself) to a luxurious rose-infused self-care experience. This beautifully curated gift set features a collection of rose-scented essentials designed to soothe, soften, and indulge the senses. Elegantly arranged inside a heart-shaped gift box, it’s the perfect present for Valentine’s Day, anniversaries, birthdays, or thoughtful moments of care.\n\nIncludes:\n\n• 3 Rose Shower Steamers, 1 oz\n• Rose Bath Salts, 1.4 oz\n• Rose Body Butter, 3.5 oz\n• Rose Bar Soap, 3.2 oz\n\nEach piece is delicately fragranced with soft floral rose notes, creating a relaxing spa-like ritual from shower to bath to body care. Ready to gift and effortlessly elegant, this set turns everyday self-care into a romantic escape.\n\nPerfect for:\nGifting, self-care rituals, spa days at home, and all occasions that call for a little extra love. 💕\n",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:39.600Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
